import newsletterFormValidation from './newsletter-validation';

if (document.querySelector('#newsletter-section form')) {
    const observer = new IntersectionObserver((entries) => {
        if (entries[0].isIntersecting === true) {
            newsletterFormValidation();
            observer.unobserve(document.querySelector('#newsletter-section form'));
        }
    }, {});
    observer.observe(document.querySelector('#newsletter-section form'));
}
